import { render, staticRenderFns } from "./ref-value.vue?vue&type=template&id=65c4d2d7&scoped=true&"
import script from "./ref-value.vue?vue&type=script&lang=js&"
export * from "./ref-value.vue?vue&type=script&lang=js&"
import style0 from "./ref-value.vue?vue&type=style&index=0&id=65c4d2d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c4d2d7",
  null
  
)

export default component.exports